const rupee = (n) => `₹${(Number(n) || 0).toLocaleString("en-IN")}`;
const hasVal = (v) => v != null && String(v) !== "";

export function orderSummaryText(order) {
  const items = order.items || [];
  const rateOf = (it) => (hasVal(it.final_rate) ? Number(it.final_rate) : hasVal(it.line_rate) ? Number(it.line_rate) : null);
  const hasRates = items.some((it) => rateOf(it) != null);
  const lines = items.map((it, i) => {
    const size = it.matched_name || `${it.dia}${it.length ? "x" + it.length : " NUT"}`;
    let s = `${i + 1}. ${size} — ${it.qty_bags} bags${it.plating ? " " + it.plating : ""}`;
    const r = rateOf(it);
    if (hasRates && r != null) s += ` @ ${rupee(r)}`;
    if (it.remarks) s += ` (${it.remarks})`;
    return s;
  });
  const head = [
    `*QUOTATION ${order.number || ""}*`.trim(),
    `Party: ${order.party || "—"}`,
    order.address ? `Address: ${order.address}` : null,
    order.gstin ? `GSTIN: ${order.gstin}` : null,
    order.date ? `Order Date: ${order.date}` : null,
    `Transport: ${order.transport || "—"}`,
    order.delivery_date ? `Delivery: ${order.delivery_date}` : null,
  ];
  const basic = !hasRates && hasVal(order.bolt_basic) ? `Basic Rate: ${rupee(order.bolt_basic)}/bag${hasVal(order.nut_basic) ? ` · Nut Basic: ${rupee(order.nut_basic)}` : ""}` : null;
  const totalBags = items.reduce((s, it) => s + (Number(it.qty_bags) || 0), 0);
  const foot = [`*Total: ${totalBags} bags*`, order.remarks ? `Remarks: ${order.remarks}` : null];
  return [...head, basic, "", ...lines, "", ...foot].filter((x) => x != null).join("\n");
}

export function shareOrderOnWhatsApp(order) {
  const text = orderSummaryText(order);
  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank", "noopener");
}
